import React, { useEffect, useState, useRef } from 'react'
import { walk } from '../db'
import Screen from './Screen'
import QuizQuestion from './QuizQuestion'
import QuizStatusBar from './QuizStatusBar'
import QuizActionBar from './QuizActionBar'
import QuizTimer from './QuizTimer'
import uniqueSampler from 'array-unique-sampler/index.js'
import { get as getFromDB } from '../db'
import { shouldEnableTimer, shouldRandomizeQuestions } from './Settings'
import { useRouter } from 'react-router5';

const availableQuestions = []

export const generateQuiz = ({ shufflePoolSize, shuffle, unit }) => {
  if (availableQuestions.length === 0) {
    walk((node, parents) => {
      if (node.type === 'Question') {
        availableQuestions.push({
          ...node.data,
          answers: node.children.filter(x => x.type === 'QuestionAnswer').map(x => x.data),
          path: parents.filter(x => x.type === 'Unit').map(x => x.id),
          pathname: parents.filter(x => x.type === 'Unit').map(x => x.name),
        })
      }
    })
  }

  const pool = unit ?
    availableQuestions.filter(x => x.path.includes(unit)) :
    availableQuestions

  return {
    questions: shuffle ?
      Array.from({
        length: Math.min(shufflePoolSize, pool.length)
      }, uniqueSampler(pool)) :
      pool
  }
}

export default ({ quiz, questionIndex, onSubmit }) => {
  // const [quiz, setQuiz] = useState(null)
  // const [questionIndex, setQuestionIndex] = useState(startingQuestionIndex)
  const [currentAnswer, changeCurrentAnswer] = useState(null)
  const [answers, setAnswers] = useState([])
  const [shouldShake, shake] = useState(false)
  const [cheating, setCheating] = useState(false)
  const canContinue = useRef(false)
  const router = useRouter()

  const chooseNextQuestion = () => {
    setAnswers(answers.concat([currentAnswer]))
    changeCurrentAnswer(null)
    router.navigate(`quiz_question`, { unit: quiz.id, question: questionIndex+1})
    // setQuestionIndex(x => x + 1);
  }

  useEffect(() => {
    canContinue.current = !!currentAnswer
  }, [currentAnswer])

  // useEffect(() => {
  //   setQuiz(generateQuiz({ questionCount, shuffle: shouldRandomizeQuestions() }))
  //   setQuestionIndex(0)
  // }, [quiz.id])

  useEffect(() => {
    shake(false)
  }, [questionIndex])

  useEffect(() => {
    if (quiz && quiz.questions.length > 1) {
      const lastAnswer = answers[answers.length - 1]

      if (lastAnswer) {
        if (!getFromDB(lastAnswer).correct) {
          onSubmit({
            answerIds: answers,
            questionIds: quiz.questions.slice(0, answers.length).map(x => x.id),
            quizId: quiz.id,
          })
        }
      }
    }
  }, [answers, quiz])

  useEffect(() => {
    if (quiz && questionIndex === quiz.questions.length && answers.length === quiz.questions.length) {
      onSubmit({
        answerIds: answers,
        questionIds: quiz.questions.map(x => x.id),
        quizId: quiz.id,
      })
    }
  }, [questionIndex, quiz])

  useEffect(() => {
    const chooseCorrectAnswer = e => {
      if (e.key === '1') {
        changeCurrentAnswer(quiz.questions[questionIndex].answers.find(x => x.correct).id)
      }

      if (e.key === '2') {
        changeCurrentAnswer(quiz.questions[questionIndex].answers.find(x => !x.correct).id)
      }

      if (e.key === 'Enter' && canContinue.current) {
        chooseNextQuestion()
      }
    }

    window.addEventListener('keyup', chooseCorrectAnswer)

    return () => {
      window.removeEventListener('keyup', chooseCorrectAnswer)
    }
  }, [quiz, questionIndex])

  if (!quiz || !quiz.questions[questionIndex]) {
    return null
  }

  const question = quiz.questions[questionIndex]

  return (
    <Screen>
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <QuizStatusBar
          quiz={quiz}
          question={question}
        />


        {shouldEnableTimer() && (
          <div>
            <QuizTimer
              questionId={question.id}
              style={{ margin: '-1rem' }}
              resolution={333}
              timeAllowed={10}
              onAlarm={() => shake(true)}
            />
          </div>
        )}

        <QuizQuestion
          answer={currentAnswer}
          question={quiz.questions[questionIndex]}
          onChange={changeCurrentAnswer}
        />
      </div>

      <QuizActionBar
        quiz={quiz}
        shake={shouldShake}
        canContinue={!!currentAnswer}
        onContinue={chooseNextQuestion}
      />
    </Screen>
  )
}